import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-subtitle-2" }
const _hoisted_2 = { class: "ml-4" }
const _hoisted_3 = { class: "d-flex justify-space-between align-items-center" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-h6 text-negative font-weight-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-subtitle-1 font-weight-bold" }

import CreditDetailViewModel from "@/viewmodels/app/CreditDetailViewModel";
import SchedulesDialog from "@/components/dialogs/SchedulesDialog.vue";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreditDetailComponent',
  setup(__props) {

const scheduleDialogRef = ref(null);
const viewModel = new CreditDetailViewModel(scheduleDialogRef);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_breadcrumbs, {
              class: "text-caption py-0 px-0",
              items: _unref(viewModel).breadcrumbs
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-chart-bar",
                  size: "small"
                })
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, { style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, { class: "rounded-sm pa-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, {
                      class: "text-subtitle-1 font-weight-bold",
                      style: {"white-space":"normal"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(viewModel).credit.value?.nom), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_1, [
                          _cache[2] || (_cache[2] = _createElementVNode("strong", null, "ID de Crédito: ", -1)),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(viewModel).credit.value?.idcredito), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_v_tooltip, {
                      text: "Copiar en portapapeles",
                      location: "bottom"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          icon: "",
                          variant: "text",
                          class: "ml-2",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewModel).copyToClipboard(_unref(viewModel).credit.value)))
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "18" }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("mdi-content-copy")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-subtitle-2 text-negative" }, "Crédito Desembolsado", -1)),
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-h6 text-primary font-weight-bold", `text-${
                _unref(viewModel).credit.value?.moneda ? 'primary' : 'grey'
              }`])
                    }, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).credit.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(_unref(viewModel).credit.value?.montodesembolsado)), 3)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-subtitle-2 text-negative" }, "Saldo Capital", -1)),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).credit.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(_unref(viewModel).credit.value?.saldo)), 1)
                  ])
                ]),
                _createVNode(_component_v_progress_linear, {
                  "model-value": 
            _unref(viewModel).percentDisbursement(
              _unref(viewModel).credit.value?.montodesembolsado,
              _unref(viewModel).credit.value?.saldo
            )
          ,
                  color: "amber",
                  height: "15",
                  class: "mt-4 rounded-lg"
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" Cronograma de Pagos ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  block: "",
                  flat: "",
                  variant: "tonal",
                  class: "mt-2 text-none",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(viewModel).showSchedule())),
                  loading: _unref(viewModel).loading.value
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" Ver Cronograma ")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" Detalles del Estado ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_container, {
                  fluid: "",
                  class: "px-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createElementVNode("span", { class: "text-subtitle-2" }, "Estado de la Cuota", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              size: "small",
                              color: 
                  _unref(viewModel).getStateColor(_unref(viewModel).credit.value?.DIAS_ATRASO)
                
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(viewModel).getStateText(_unref(viewModel).credit.value?.DIAS_ATRASO)), 1)
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createElementVNode("span", { class: "text-subtitle-2" }, "Días de Atraso", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right text-subtitle-2"
                        }, {
                          default: _withCtx(() => [
                            (_unref(viewModel).credit.value?.DIAS_ATRASO <= 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "0"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(viewModel).credit.value?.DIAS_ATRASO), 1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createElementVNode("span", { class: "text-subtitle-2" }, "Fecha de Vencimiento", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right text-subtitle-2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_unref(viewModel).formatDate(
                    _unref(viewModel).credit.value?.FEC_CUOTA_X_VENCER
                  )), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createElementVNode("span", { class: "text-subtitle-2" }, "Número de Cuota", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right text-subtitle-2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_unref(viewModel).credit.value?.CUOTA_X_VENCER) + " de " + _toDisplayString(_unref(viewModel).credit.value?.cronogramas?.length || 0), 1)
                          ]),
                          _: 1
                        }),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "6"
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createElementVNode("span", { class: "text-subtitle-2" }, "Saldo Capital", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "6",
                              class: "text-right text-subtitle-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).credit.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(
                    _unref(viewModel).credit_vence.value?.capital ?? 0
                  )), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "6"
                            }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createElementVNode("span", { class: "text-subtitle-2" }, "Interés", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "6",
                              class: "text-right text-subtitle-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).credit.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(
                    _unref(viewModel).credit_vence.value?.interes ?? 0
                  )), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 4,
                              cols: "6"
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createElementVNode("span", { class: "text-subtitle-2" }, "Mora", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 5,
                              cols: "6",
                              class: "text-right text-subtitle-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).credit.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(_unref(viewModel).credit_vence.value?.mora ?? 0)), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 6,
                              cols: "6",
                              class: "font-weight-bold text-subtitle-2"
                            }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createElementVNode("span", null, "Cuota a Pagar", -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(viewModel).credit_vence)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 7,
                              cols: "6",
                              class: "text-right text-subtitle-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).credit.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(
                    _unref(viewModel).credit_vence.value?.montocuota || 0
                  )), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode(" Movimientos ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                (_unref(viewModel).credit.value?.movimientos.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_v_alert, {
                        type: "info",
                        class: "text-center text-subtitle-2",
                        variant: "tonal",
                        text: "Actualmente no tienes movimientos.",
                        border: ""
                      })
                    ]))
                  : (_openBlock(), _createBlock(_component_v_list, {
                      key: 1,
                      class: "overflow-y-auto",
                      "max-height": "393"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).credit.value?.movimientos, (mov, idx) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 'mov-' + idx,
                            class: "pa-4"
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_avatar, {
                                rounded: "lg",
                                size: "48",
                                variant: "tonal",
                                color: _unref(viewModel).getColor(mov.tipomov)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "20" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(viewModel).getIconName(mov.tipomov)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(mov.CONCEPTO), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(mov.FECHA_AMORTIZACION) + " " + _toDisplayString(mov.HORA_AMORTIZACION), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            append: _withCtx(() => [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).credit.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(mov.MONTO_AMORTIZACION)), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(SchedulesDialog, {
      ref_key: "scheduleDialogRef",
      ref: scheduleDialogRef
    }, null, 512)
  ], 64))
}
}

})